import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Sintija
 * id 11D80B18-006C-4929-8CEA-29D2C8BED5B7
 * name artboard
 * version: 7.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/artboard.svg
 * tags
 * - Drawing / Art 
 */
export const ArtboardIcon = createSvgIcon(<><path d="M17 9V15H7V9H17M19 3H17V6H19V3M7 3H5V6H7V3M23 7H20V9H23V7M19 7H5V17H19V7M4 7H1V9H4V7M23 15H20V17H23V15M4 15H1V17H4V15M19 18H17V21H19V18M7 18H5V21H7V18Z" /></>, 'ArtboardIcon');
export default ArtboardIcon